/**
 * Returns a date object that is the number of years ago from the current date
 * @param years - The number of years ago to return
 * @returns A date object that is the number of years ago from the current date
 * @example
 * dateYearsAgo(1) // Returns a date object that is 1 year ago from the current date
 */
export default function dateYearsAgo(years: number) {
  const currentDate = new Date()
  const year = currentDate.getFullYear() - years
  const dateYearsAgo = new Date()

  dateYearsAgo.setFullYear(year)

  return dateYearsAgo
}
